
(function () {
  'use strict';

  /* ─── Selectors ───────────────────────────────────────────────── */
  var SECTION_SELECTOR   = '.t4s-section-main [data-ntajax-options]';
  var GRID_SELECTOR      = '[data-contentlm-replace]';
  var PREV_WRAP_SELECTOR = '[data-wrap-lm-prev]';
  var PREV_BTN_SELECTOR  = '[data-load-more][data-is-prev]';
  var NEXT_BTN_SELECTOR  = '[data-load-more]:not([data-is-prev])';
  var PRODUCT_LINK       = 'a[href*="/products/"]';

  /* ─── Config ──────────────────────────────────────────────────── */
  var RETRY_DELAY   = 120;
  var RETRY_LIMIT   = 50;
  /* Adaptive prefetch window for the prev-button IntersectionObserver.
     We scale it with viewport height so the next 1-2 pages can load before
     the button is visually exposed. */
  var ROOT_MARGIN_MIN = 900;
  var ROOT_MARGIN_MULT = 1.4;

  /* sessionStorage keys used for the back-from-PDP snapshot */
  var SS_HTML       = '__dv_snap_html__';
  var SS_SCROLL     = '__dv_snap_scroll__';
  var SS_ACTIVE     = '__dv_snap_active__';

  /* ─── State ───────────────────────────────────────────────────── */
  var raf = window.requestAnimationFrame
    ? window.requestAnimationFrame.bind(window)
    : function (fn) { return setTimeout(fn, 16); };

  var booted = false;
  var state = {
    buttonObserver : null,
    nextObserver   : null,
    gridObserver   : null,
    wrapObserver   : null,
    observedButton : null,
    observedNextButton : null,
    pendingAnchor  : null,
    pendingRebind  : false,
    rebindTimer    : 0
  };

  /* ─── Utilities ───────────────────────────────────────────────── */
  function ss(key, val) {
    try {
      if (val === undefined) return sessionStorage.getItem(key);
      if (val === null)      sessionStorage.removeItem(key);
      else                   sessionStorage.setItem(key, val);
    } catch (e) { /* quota or privacy mode */ }
  }

  function getContainer()  { return document.querySelector(SECTION_SELECTOR); }
  function getGrid(el)     { return el ? el.querySelector(GRID_SELECTOR) : null; }
  function getPrevWrap(el) { return el ? el.querySelector(PREV_WRAP_SELECTOR) : null; }
  function getPrevBtn(el)  { return el ? el.querySelector(PREV_BTN_SELECTOR) : null; }
  function getNextBtn(el)  { return el ? el.querySelector(NEXT_BTN_SELECTOR) : null; }
  function getScrollY()    { return window.pageYOffset || document.documentElement.scrollTop || 0; }

  function setManualScrollRestoration() {
    try {
      if ('scrollRestoration' in history) {
        history.scrollRestoration = 'manual';
      }
    } catch (e) {}
  }

  function setScrollAnchoringDisabled(disabled) {
    var root = document.documentElement;
    var body = document.body;

    if (root && root.style) {
      if (disabled) root.style.setProperty('overflow-anchor', 'none');
      else root.style.removeProperty('overflow-anchor');
    }

    if (body && body.style) {
      if (disabled) body.style.setProperty('overflow-anchor', 'none');
      else body.style.removeProperty('overflow-anchor');
    }
  }

  function getPrevRootMargin() {
    var viewport = window.innerHeight || document.documentElement.clientHeight || 0;
    var prefetch = Math.max(ROOT_MARGIN_MIN, Math.round(viewport * ROOT_MARGIN_MULT));
    return prefetch + 'px 0px 0px 0px';
  }

  function getNextRootMargin() {
    var viewport = window.innerHeight || document.documentElement.clientHeight || 0;
    var prefetch = Math.max(ROOT_MARGIN_MIN, Math.round(viewport * ROOT_MARGIN_MULT));
    return '0px 0px ' + prefetch + 'px 0px';
  }

  function disconnect(name) {
    if (state[name]) { state[name].disconnect(); state[name] = null; }
  }

  function waitForFacets(el, attempt) {
    attempt = attempt || 0;
    if (!el)             return Promise.resolve(null);
    if (el.Facets)       return Promise.resolve(el.Facets);
    if (attempt >= RETRY_LIMIT) return Promise.resolve(null);
    return new Promise(function (resolve) {
      setTimeout(function () {
        waitForFacets(el, attempt + 1).then(resolve);
      }, RETRY_DELAY);
    });
  }

  /* ════════════════════════════════════════════════════════════════
     FIX #1 — Snapshot + Restore (Back from PDP)
     ════════════════════════════════════════════════════════════════ */

  /**
   * Save a snapshot of the current collection state to sessionStorage.
   * Called just before the browser navigates to a PDP.
   */
  function saveSnapshot() {
    var el = getContainer();
    if (!el) return;

    /* Only save if we're on a collection page */
    if (!location.pathname.includes('/collections/')) return;

    try {
      /* Save innerHTML of the full container (product cards + pagination buttons).
         This is exactly what facets.min.js would replace on popstate — we save it
         so we can restore it ourselves without an AJAX round-trip. */
      ss(SS_HTML,   el.innerHTML);
      ss(SS_SCROLL, String(getScrollY()));
      ss(SS_ACTIVE, '1');
    } catch (e) {
      /* If saving fails (e.g., quota), clear any partial state */
      clearSnapshot();
    }
  }

  function clearSnapshot() {
    ss(SS_HTML,   null);
    ss(SS_SCROLL, null);
    ss(SS_ACTIVE, null);
  }

  /**
   * Restore the saved snapshot into the DOM and scroll to the saved position.
   * Returns true if restoration succeeded.
   */
  function restoreSnapshot() {
    if (!ss(SS_ACTIVE)) return false;

    var html      = ss(SS_HTML);
    var scrollStr = ss(SS_SCROLL);
    if (!html) { clearSnapshot(); return false; }

    var el = getContainer();
    if (!el) { clearSnapshot(); return false; }
    var facets = el.Facets;

    setScrollAnchoringDisabled(true);

    /* ── 1. Restore DOM synchronously (no AJAX, no CLS) ── */
    el.innerHTML = html;

    /* ── 2. Remove the 'already-observed' guard class so facets can
            re-attach the IntersectionObserver to the next-load-more button ── */
    el.querySelectorAll('[data-load-onscroll].t4s-lm-onscroll-init')
      .forEach(function (btn) { btn.classList.remove('t4s-lm-onscroll-init'); });

    /* ── 3. Clear facets' internal page cache before the next auto-load ── */
    if (facets && Array.isArray(facets.filterData)) {
      facets.filterData = [];
    }

    /* ── 4. Re-trigger lazy image loading ── */
    if (window.lazySizesT4 && lazySizesT4.autoSizer) {
      try { lazySizesT4.autoSizer.checkElems(); } catch (e) {}
    }
    if (window.lazySizes) {
      try { lazySizes.autoSizer.checkElems(); } catch (e) {}
    }

    /* ── 5. Re-init wishlist buttons (if SmartWishlist or similar) ── */
    try {
      if (window.SmartWishlist && typeof SmartWishlist.init === 'function') {
        SmartWishlist.init();
      }
    } catch (e) {}

    /* ── 6. Restore scroll position ──
            Because image containers use CSS aspect-ratio (--aspect-ratioapt: 0.75),
            the layout height is stable immediately after innerHTML restore.
            We scroll in the same frame for instant, jerk-free positioning. */
    var savedScroll = scrollStr ? parseInt(scrollStr, 10) : 0;
    if (savedScroll > 0) {
      /* Immediate scroll to get position right away */
      window.scrollTo(0, savedScroll);

      /* Belt-and-suspenders: re-apply after one rAF in case anything
         slightly shifts the layout (e.g., a sticky header reflow) */
      raf(function () {
        window.scrollTo(0, savedScroll);
      });
    }

    /* ── 7. Clear snapshot so a fresh collection visit doesn't restore stale data ── */
    clearSnapshot();

    /* ── 8. Re-attach the next-page observer after the final scroll settles ── */
    raf(function () {
      refreshNextLoadObserver(facets);
    });

    return true;
  }

  /* ── Intercept product link clicks to save snapshot ── */
  document.addEventListener('click', function (e) {
    /* Find the closest product anchor */
    var link = e.target.closest(PRODUCT_LINK);
    if (!link) return;
    if (e.defaultPrevented || e.button !== 0) return;

    /* Only save when we're actually on a collection page */
    if (!location.pathname.includes('/collections/')) return;

    /* Don't save if no multi-page content is loaded yet (page 1 fresh load) */
    var el = getContainer();
    if (!el) return;

    saveSnapshot();
  }, true); /* capture phase so we run before any preventDefaults */

  /* ── Intercept popstate in capture phase BEFORE facets.min.js jQuery handler ── */
  window.addEventListener('popstate', function (e) {
    /* Check if this popstate is a "back from PDP" event */
    if (!ss(SS_ACTIVE)) return; /* Not our event — let facets.min.js handle it */

    /* Prevent facets.min.js jQuery popstate handler from running.
       jQuery binds in bubble phase; we're in capture phase → we run first. */
    e.stopImmediatePropagation();

    /* Restore the snapshot */
    var restored = restoreSnapshot();

    if (!restored) {
      /* Fallback: if restoration failed, let the page reload naturally */
      location.reload();
    }
  }, true); /* CRITICAL: capture phase */

  /* ── Handle pageshow (bfcache) as a secondary fallback ── */
  window.addEventListener('pageshow', function (e) {
    if (!e.persisted) return; /* Not a bfcache restore, ignore */

    setManualScrollRestoration();
    setScrollAnchoringDisabled(true);

    /* Browser restored page from bfcache — apply saved scroll if available */
    var scrollStr = ss(SS_SCROLL);
    if (!scrollStr) return;
    var savedScroll = parseInt(scrollStr, 10);
    if (savedScroll > 0) {
      setTimeout(function () { window.scrollTo(0, savedScroll); }, 0);
    }
  });


  /* ════════════════════════════════════════════════════════════════
     FIX #2 — Load-Previous auto-trigger + scroll anchor (no jerk)
     ════════════════════════════════════════════════════════════════ */

  function clearPendingAnchor() {
    if (state.pendingAnchor && state.pendingAnchor.timer) {
      clearTimeout(state.pendingAnchor.timer);
    }
    state.pendingAnchor = null;
  }

  function maybeFlushRebind(sectionEl, facets) {
    if (!state.pendingRebind || state.pendingAnchor) return;
    state.pendingRebind = false;
    bindPrevButton(sectionEl, facets);
  }

  /**
   * After new content is prepended (Load Previous), the page height grows
   * above the current viewport, which pushes everything down.
   * We compensate by scrolling down by the exact height delta.
   * We wait for height to STABILIZE across multiple frames before applying.
   */
  function releaseAnchor(sectionEl, facets, gridEl) {
    if (!state.pendingAnchor || state.pendingAnchor.raf) return;

    var anchor   = state.pendingAnchor;
    var attempts = 0;
    var lastH    = gridEl.offsetHeight;

    function check() {
      attempts++;
      var currH = gridEl.offsetHeight;
      /* Keep checking until height is stable for 2 consecutive frames,
         or until we've waited long enough (10 frames max) */
      if (currH !== lastH && attempts < 10) {
        lastH = currH;
        state.pendingAnchor.raf = raf(check);
        return;
      }
      /* Height has stabilized — apply scroll compensation */
      var delta = currH - anchor.startHeight;
      if (delta > 0) {
        window.scrollTo(0, anchor.startScroll + delta);
      }
      clearPendingAnchor();
      maybeFlushRebind(sectionEl, facets);
    }

    state.pendingAnchor.raf = raf(check);
  }

  function beginAnchor(gridEl) {
    clearPendingAnchor();
    state.pendingAnchor = {
      startScroll : getScrollY(),
      startHeight : gridEl.offsetHeight,
      raf         : 0,
      timer       : setTimeout(function () { clearPendingAnchor(); }, 15000)
    };
  }

  function bindPrevButton(sectionEl, facets) {
    var prevBtn = getPrevBtn(sectionEl);
    if (!prevBtn) {
      disconnect('buttonObserver');
      state.observedButton = null;
      return;
    }
    /* Already observing this exact button — skip */
    if (state.observedButton === prevBtn && state.buttonObserver) return;

    disconnect('buttonObserver');
    state.observedButton = prevBtn;

    if (!window.IntersectionObserver) return;

    state.buttonObserver = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        var btn    = entry.target;
        var gridEl = getGrid(sectionEl);
        if (!btn) return;

        /* If button is hidden (display:none parent), stop observing */
        if (btn.offsetParent === null) {
          if (state.buttonObserver) state.buttonObserver.unobserve(btn);
          return;
        }
        if (!entry.isIntersecting) return;
        if (btn.classList.contains('is--loading')) return;
        if (!gridEl) return;

        /* Unobserve immediately to prevent double-firing */
        if (state.buttonObserver) state.buttonObserver.unobserve(btn);

        /* Begin scroll anchor BEFORE the click so we capture the pre-load height */
        beginAnchor(gridEl);
        btn.click();
      });
    }, {
      root       : null,
      rootMargin : getPrevRootMargin(),
      threshold  : 0
    });

    state.buttonObserver.observe(prevBtn);
  }

  function bindNextButton(sectionEl, facets) {
    var nextBtn = getNextBtn(sectionEl);
    if (!nextBtn) {
      disconnect('nextObserver');
      state.observedNextButton = null;
      return;
    }
    if (state.observedNextButton === nextBtn && state.nextObserver) return;

    disconnect('nextObserver');
    state.observedNextButton = nextBtn;

    if (nextBtn.classList) {
      nextBtn.classList.remove('t4s-lm-onscroll-init');
    }

    if (!window.IntersectionObserver) return;

    state.nextObserver = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        var btn = entry.target;
        var gridEl = getGrid(sectionEl);
        if (!btn) return;

        if (btn.offsetParent === null) {
          if (state.nextObserver) state.nextObserver.unobserve(btn);
          return;
        }
        if (!entry.isIntersecting) return;
        if (btn.classList.contains('is--loading')) return;
        if (!gridEl) return;

        if (state.nextObserver) state.nextObserver.unobserve(btn);
        btn.click();
      });
    }, {
      root       : null,
      rootMargin : getNextRootMargin(),
      threshold  : 0
    });

    state.nextObserver.observe(nextBtn);
  }

  function bindGridObserver(sectionEl, facets) {
    var gridEl = getGrid(sectionEl);
    disconnect('gridObserver');
    if (!gridEl || typeof MutationObserver === 'undefined') return;

    state.gridObserver = new MutationObserver(function (mutations) {
      var hasNew = mutations.some(function (m) {
        return m.addedNodes && m.addedNodes.length > 0;
      });
      if (!hasNew || !state.pendingAnchor) return;
      releaseAnchor(sectionEl, facets, gridEl);
    });

    state.gridObserver.observe(gridEl, { childList: true });
  }

  function bindWrapObserver(sectionEl, facets) {
    var prevWrap = getPrevWrap(sectionEl);
    disconnect('wrapObserver');
    if (!prevWrap || typeof MutationObserver === 'undefined') return;

    state.wrapObserver = new MutationObserver(function () {
      if (state.rebindTimer) clearTimeout(state.rebindTimer);
      state.pendingRebind = true;
      state.rebindTimer = setTimeout(function () {
        state.rebindTimer = 0;
        maybeFlushRebind(sectionEl, facets);
      }, 0);
    });

    state.wrapObserver.observe(prevWrap, { childList: true });
  }

  function refreshNextLoadObserver(facets) {
    if (!facets || typeof facets.clickOnScrollButton !== 'function') return;

    var sectionEl = getContainer();
    if (sectionEl) {
      sectionEl.querySelectorAll('[data-load-onscroll].t4s-lm-onscroll-init')
        .forEach(function (btn) { btn.classList.remove('t4s-lm-onscroll-init'); });
    }

    // Re-attach the next-page observer after collection swaps so infinite
    // scroll keeps working on the newly injected button.
    bindNextButton(sectionEl, facets);
    facets.clickOnScrollButton = function () {
      bindNextButton(sectionEl, facets);
    };
  }

  function installNextObserverPatch(facets) {
    if (!facets || !facets.constructor || !facets.constructor.prototype) return;

    var proto = facets.constructor.prototype;
    if (proto.__dv_next_click_patch) return;

    proto.__dv_next_click_patch = true;
    proto.__dv_next_click_on_scroll_original = proto.clickOnScrollButton;
    proto.clickOnScrollButton = function () {
      bindNextButton(getContainer(), this);
    };
  }

  function invalidateFacetInstanceForSwitch() {
    var sectionEl = getContainer();
    if (!sectionEl) return;

    /* collection-switcher swaps innerHTML only, so the old Facets instance
       keeps cached child references. Removing the enabled flag lets
       facets.min.js build a fresh instance for the new collection DOM. */
    sectionEl.classList.remove('is--enabled');
    sectionEl.querySelectorAll('[data-load-onscroll].t4s-lm-onscroll-init')
      .forEach(function (btn) { btn.classList.remove('t4s-lm-onscroll-init'); });
    try {
      installNextObserverPatch(sectionEl.Facets);
      sectionEl.Facets = null;
      delete sectionEl.Facets;
    } catch (e) {
      sectionEl.Facets = null;
    }
  }

  /* ════════════════════════════════════════════════════════════════
     Boot
     ════════════════════════════════════════════════════════════════ */

  function start() {
    if (booted) return;
    setManualScrollRestoration();
    setScrollAnchoringDisabled(true);
    var sectionEl = getContainer();
    if (!sectionEl) return;
    if (!sectionEl.classList.contains('t4s-main-collection-page')) return;

    waitForFacets(sectionEl, 0).then(function (facets) {
      if (!facets || booted) return;
      booted = true;
      if (facets.constructor && facets.constructor.prototype && facets.constructor.prototype.__dv_next_click_patch) {
        refreshNextLoadObserver(facets);
      }
      bindPrevButton(sectionEl, facets);
      bindGridObserver(sectionEl, facets);
      bindWrapObserver(sectionEl, facets);
    });
  }

  function restart() {
    disconnect('buttonObserver');
    disconnect('nextObserver');
    disconnect('gridObserver');
    disconnect('wrapObserver');
    clearPendingAnchor();
    state.observedButton = null;
    state.observedNextButton = null;
    state.pendingRebind  = false;
    if (state.rebindTimer) clearTimeout(state.rebindTimer);
    state.rebindTimer = 0;
    booted = false;
    start();
  }

  document.addEventListener('collection:switched', function () {
    invalidateFacetInstanceForSwitch();
    setTimeout(restart, 0);
  }, true);

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      setTimeout(start, 0);
    }, { once: true });
  } else {
    setTimeout(start, 0);
  }

})();
